var styleDataHash = 'a659ae25';  
export const injectCss = (() => {
  var css = `@charset "UTF-8";._6fhlr,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.pk8nW{align-items:center;box-sizing:border-box;display:flex;font-family:var(--ricos-settings-text-font-family,Madefor,"Helvetica Neue",Helvetica,Arial,メイリオ,meiryo,"ヒラギノ角ゴ pro w3","hiragino kaku gothic pro",sans-serif);width:min-content;z-index:10}[dir] .pk8nW{background-color:#fff;border:1px solid rgba(51,51,51,.1);box-shadow:none}.SDhs1{height:47px}[dir] .SDhs1{padding:8px 12px}.NxLTN{height:40px}[dir] .NxLTN{padding:0 4px}.F7F8m{align-items:center;display:flex;grid-column-gap:4px;width:max-content}`;
  var isTest = typeof process !== 'undefined' && process.env && process.env['NODE_ENV'] === 'test';

  if (isTest || !css || typeof document === 'undefined') { return; }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.setAttribute('data-ricos-style-hash', styleDataHash);
  style.type = 'text/css';

  head.appendChild(style);

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});

injectCss();



export default {
  "fontElementMap": "_6fhlr",
  "moreItems": "pk8nW",
  "moreItemsStatic": "SDhs1",
  "moreItemsFloating": "NxLTN",
  "overflownItems": "F7F8m"
};